import { Spin } from 'antd';

const Loader = () => {
  return (
    <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100vw',
          position: 'absolute',
          top: 0,
          left: 0,
          background: 'rgba(0, 0, 0, 0.2)',
        }}
      >
        <Spin size="large" />
      </div>
  )
}

export default Loader;